export interface AudioHelperPlayer {
  play: () => Promise<void> | void
  seekTo: (seconds: number) => Promise<void> | void
}

export type AudioModeSetter = (mode: {
  playsInSilentMode: boolean
  allowsRecording: boolean
  interruptionMode?: 'mixWithOthers' | 'doNotMix' | 'duckOthers'
  shouldRouteThroughEarpiece?: boolean
}) => Promise<void>

export async function playAudioHelper(params: {
  setAudioMode: AudioModeSetter
  player: AudioHelperPlayer
  audioMode?: {
    playsInSilentMode: boolean
    allowsRecording: boolean
    interruptionMode?: 'mixWithOthers' | 'doNotMix' | 'duckOthers'
    shouldRouteThroughEarpiece?: boolean
  }
}): Promise<void> {
  const { setAudioMode, player, audioMode } = params

  await setAudioMode(
    audioMode ?? {
      playsInSilentMode: true,
      allowsRecording: false,
      interruptionMode: 'mixWithOthers',
    },
  )
  await Promise.resolve(player.seekTo(0))
  await Promise.resolve(player.play())
}
